import Module from "lib/module";
import * as Constants from "constants";

import Vue from "vue";
import VueResource from "vue-resource";
import Spinner from "vue-simple-spinner";
import flatpickr from "flatpickr";

import Collapse from "bootstrap-vue";
import MdField from "vue-material/dist/components/mdfield";
import vueSmoothScroll from "vue-smoothscroll";
import * as ModalDialogs from "vue-modal-dialogs";

import ClaimsHistoryFilter from "./components/claims/claims-history-filter.vue";
import ClaimsHistoryResults from "./components/claims/claims-history-results.vue";
import ClaimsHistoryDetail from "./components/claims/claims-history-detail.vue";
import DirectoryFilter from "./components/directory/directory-filter.vue";
import DirectoryItem from "./components/directory/directory-item.vue";
import NewsFilter from "./components/news/news-filter.vue";
import WebinarsFilter from "./components/webinars/webinars-filter.vue";
import WebinarsResults from "./components/webinars/webinars-results.vue";
import NewsResults from "./components/news/news-results.vue";
import PricingFilter from "./components/pricing-updates/pricing-filter.vue";
import PricingResults from "./components/pricing-updates/pricing-results.vue";
import ManageUser from "./components/account/manage-user.vue";
import MarketReportsFilter from "./components/market-reports/market-reports-filter.vue";
import MarketRerportsResults from "./components/market-reports/market-reports-results.vue";
import MarketWatch from "./components/market-reports/market-watch.vue";
import MemberProgramFilter from "./components/member-programs/member-program-filter.vue";
import MemberProgramResults from "./components/member-programs/member-program-results.vue";
import ProductFilter from "./components/products/product-filter.vue";
import ProductItem from "./components/products/product-item.vue";
import ProductSearch from "./components/products/product-search.vue";
import SpecialsFilter from "./components/specials/specials-filter.vue";
import SpecialsItem from "./components/specials/specials-item.vue";
import SupplierAdd from "./components/accounting-tracking/supplier-add.vue";
import SupplierItem from "./components/accounting-tracking/supplier-item.vue";
import SupplierRemove from "./components/accounting-tracking/supplier-remove.vue";
import UserSearch from "./components/account/user-search.vue";

import SearchInput from "./components/shared/search-input.vue";
import Pagination from "./components/shared/pagination.vue";
import Typeahead from "./components/shared/typeahead.vue";

import { create } from "vue-modal-dialogs";
import * as ModalResponse from "./common/modal-response.js";

const addAllCapSuppliersDialog = create(SupplierAdd, "result");

@Module.define("search")
class Main extends Module {
  constructor(options) {
    super(options);

    this.apiurl = Constants.ENVIRONMENT_API + $("#listing-app").data("api");
    this.apiNodeID = $("#listing-app").data("nodeid");
    this.apiAddOns = "";
    this.claimsCsvApi = "GetHistoryCsv?";
    this.claimsFilterApi = "claims/filterhistory?";
    this.directoryExportApi = "directory/csv?";
    this.directoryFilterApi = "directory/filterdirectory?";
    this.newsFilterApi = "news?parentNodeID=";
    this.publicNewsFilterApi = "publicnews?parentNodeID=";
    this.pricingFilterApi = "priceupdate?parentNodeID=";
    this.productFilterApi = "products?";
    this.specialFilterApi = "specials?parentNodeID=";
    this.usersFilterApi = "user/filterUsers?";
    this.securityHeaders = new Headers({
      AuthenticatedUser: window.LMC.authenticatedUser,
    });
  }

  main() {
    Vue.use(VueResource);
    Vue.use(MdField);
    Vue.use(Collapse);
    Vue.use(vueSmoothScroll);
    Vue.use(ModalDialogs);

    if (this.apiNodeID != null) {
      this.apiurl += `?parentNodeID=${this.apiNodeID}&`;
    } else {
      this.apiurl += `?`;
    }
    this.vueApp();
  }

  vueApp() {
    let _this = this;

    const app = new Vue({
      el: "#listing-app",
      data: {
        capSupplierToggle: {
          isAdd: false,
          supplierId: "",
        },
        isClaimQuery: false,
        isDirectoryQuery: false,
        isNewsMySuppliersQuery: false,
        isPricingMySuppliersQuery: false,
        isProductQuery: false,
        isSpecialQuery: false,
        isUserQuery: false,
        isUserPagerCall: false,
        showfilters: false,
        loading: true,
        results: [],
        searchText: "",
        filters: [],
        selectedProducts: [],
        allProductsSelected: false,
        isProductsActionsEnabled: false,
        isExporting: false,
        selectedSpecials: [],
        allSpecialsSelected: false,
        isSpecialsActionsEnabled: false,
        claimsIsDesc: true,
        directoryIsDesc: true,
        sortOrder: {
          isNameAsc: true,
          isRatingAsc: true,
        },
        sortQuery: {
          orderBy: "",
          direction: "",
        },
        pageSize:
          window.pager != null ? window.pager.PageSize.toString() : null,
        pagination: {
          current_page: window.pager != null ? window.pager.CurrentPage : null,
          start_page: window.pager != null ? window.pager.StartPage : null,
          end_page: window.pager != null ? window.pager.EndPage : null,
          page_size: window.pager != null ? window.pager.PageSize : null,
        },
      },
      mounted() {
        // Clear any previous product selections when landing page loads
        this.clearCookie("selectedProducts");
        this.results = window.listing != null ? window.listing : [];

        let initialLoad = document.getElementsByClassName("initial-load")[0];
        let contentWrap = document.getElementsByClassName("content-wrapper")[0];
        if (initialLoad != undefined) {
          initialLoad.classList.add("hide");
          contentWrap.classList.remove("loading");
        }

        this.loading = false;
      },
      watch: {
        showFilters: function(newVal) {
          let filter = document.getElementById("filter");

          if (newVal === true) {
            filter.classList.add("open");
          } else {
            filter.classList.remove("open");
          }
        },
      },
      components: {
        "claims-history-filter": ClaimsHistoryFilter,
        "claims-history-results": ClaimsHistoryResults,
        "claims-history-detail": ClaimsHistoryDetail,
        "directory-filter": DirectoryFilter,
        "directory-item": DirectoryItem,
        pagination: Pagination,
        "manage-user": ManageUser,
        "market-reports-filter": MarketReportsFilter,
        "market-reports-results": MarketRerportsResults,
        "market-watch": MarketWatch,
        "member-program-filter": MemberProgramFilter,
        "member-program-results": MemberProgramResults,
        "news-filter": NewsFilter,
        "webinars-filter": WebinarsFilter,
        "webinars-results": WebinarsResults,
        "news-results": NewsResults,
        "pricing-filter": PricingFilter,
        "pricing-results": PricingResults,
        "product-filter": ProductFilter,
        "product-item": ProductItem,
        "product-search": ProductSearch,
        "specials-filter": SpecialsFilter,
        "specials-item": SpecialsItem,
        "search-input": SearchInput,
        "supplier-add": SupplierAdd,
        "supplier-item": SupplierItem,
        "supplier-remove": SupplierRemove,
        typeahead: Typeahead,
        "user-search": UserSearch,
        "vue-simple-spinner": Spinner,
      },
      methods: {
        //Primary Global Methods
        getSecureFilteredResults(apiPath) {
          let ajaxLoadTimeout = setTimeout(() => {
            this.loading = true;
            this.results = [];
          }, 1000);

          let fetchUrl =
            Constants.ENVIRONMENT_API +
            apiPath +
            `page=${this.pagination.current_page}` +
            _this.apiAddOns;

          fetch(fetchUrl, {
            headers: _this.securityHeaders,
          })
            .then((response) => {
              if (response.ok) {
                return Promise.resolve(response);
              } else {
                return Promise.reject(new Error(error));
              }
            })
            .then((response) => response.json())
            .then((data) => {
              // stuff on success
              this.results = data.Data;

              if (
                this.isUserQuery ||
                this.isDirectoryQuery ||
                this.isProductQuery ||
                this.isSpecialQuery ||
                this.isNewsMySuppliersQuery ||
                this.isPricingMySuppliersQuery
              ) {
                this.results = data.Data.Items;

                this.pagination.current_page = data.Data.Pager.CurrentPage;
                this.pagination.start_page = data.Data.Pager.StartPage;
                this.pagination.end_page = data.Data.Pager.EndPage;
                this.pagination.page_size = data.Data.Pager.PageSize;

                window.pager.TotalItems = data.Data.Pager.TotalItems;
              }

              clearTimeout(ajaxLoadTimeout);

              this.loading = false;
            })
            .catch((error) => {
              console.log(error);
            });
        },
        getClaimsCsv() {
          let csvUrl = _this.claimsCsvApi + _this.apiAddOns;

          window.location = csvUrl;
        },
        getDirectoryExport() {
          let exportUrl =
            _this.directoryExportApi +
            _this.apiAddOns +
            "&recordCount=" +
            window.pager.TotalItems;

          window.location = exportUrl;
        },
        getSpecialsExport(cookieName, selectedList) {
          let cookieValue = "";
          let first = true;

          // Build the cookie value
          selectedList.forEach(function(item) {
            if (!first) {
              cookieValue += ":";
            }

            if (item.NodeID !== 0) {
              cookieValue += "Kentico|" + item.NodeID;
            } else {
              cookieValue += "LMC|" + item.LmcSpecialID;
            }

            first = false;
          });

          this.setCookie(cookieName, cookieValue);
          window.location.href = "/members/products/specials-promotions/export";
        },
        getProductsExport(cookieName, selectedList) {
          this.isExporting = true;
          let cookieValue = selectedList
            .map((item) => item.SupplierId)
            .join("|");
          this.setCookie(cookieName, cookieValue);

          fetch("/members/products/export", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              AuthenticatedUser: window.LMC.authenticatedUser,
            },
            body: JSON.stringify({ cookieName: cookieValue }),
          })
            .then((response) => {
              if (response.ok) {
                return response.blob();
              } else {
                throw new Error("Export failed");
              }
            })
            .then((blob) => {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = "productsExport.xlsx";
              document.body.appendChild(a);
              a.click();
              a.remove();
              window.URL.revokeObjectURL(url);
              this.isExporting = false;
            })
            .catch((error) => {
              console.error("Error:", error);
              this.isExporting = false;
            });
        },
        getResults() {
          let ajaxLoadTimeout = setTimeout(() => {
            this.loading = true;
            this.results = [];
          }, 1000);

          let fetchUrl =
            `${_this.apiurl}page=${this.pagination.current_page}` +
            _this.apiAddOns;

          if (!fetchUrl.includes("&itemsperpage")) {
            fetchUrl += "&itemsperpage=" + this.pagination.page_size;
          }

          fetch(fetchUrl, {
            headers: _this.securityHeaders,
          })
            .then((response) => {
              if (response.ok) {
                return Promise.resolve(response);
              } else {
                return Promise.reject(new Error(error));
              }
            })
            .then((response) => response.json())
            .then((data) => {
              // stuff on success
              this.results = data.Data.Items;

              if (data.Data.Pager != null) {
                this.pagination.current_page = data.Data.Pager.CurrentPage;
                this.pagination.start_page = data.Data.Pager.StartPage;
                this.pagination.end_page = data.Data.Pager.EndPage;
                this.pagination.page_size = data.Data.Pager.PageSize;
              }

              this.allProductsSelected = false;
              this.allSpecialsSelected = false;

              clearTimeout(ajaxLoadTimeout);
              this.loading = false;
            })
            .catch((error) => {
              console.log(error);
            });
        },
        postResults(url, params, callback) {
          let ajaxLoadTimeout = setTimeout(() => {
            this.loading = true;
            this.results = [];
          }, 1000);

          fetch(url, params)
            .then((response) => {
              if (response.ok) {
                callback;
                return Promise.resolve(response);
              } else {
                return Promise.reject(new Error(error));
              }
            })
            .then((response) => response.json())
            .then((data) => {
              // stuff on success

              if (data !== null) {
                this.results = data;
              }

              clearTimeout(ajaxLoadTimeout);
              this.loading = false;

              //callback
            })
            .catch((error) => {
              console.log(error);
            });
        },
        applyFilters(filters) {
          _this.apiAddOns = "";
          this.filters = filters;

          if (Array.isArray(this.filters.promotionTypes)) {
            this.filters.promotionTypes =
              this.filters.promotionTypes &&
              encodeURIComponent(this.filters.promotionTypes);
          }

          if (Array.isArray(this.filters.categories)) {
            this.filters.categories =
              this.filters.categories &&
              encodeURIComponent(this.filters.categories.join(","));
          }

          if (!this.filters.promotionTypes) {
            this.filters.promotionTypes = "";
          }

          if (!this.filters.categories) {
            this.filters.categories = "";
          }

          // if search term isn't empty, add to api url
          if (this.searchText !== "") {
            _this.apiAddOns +=
              "&keywords=" + encodeURIComponent(this.searchText);
          }

          for (let filter of Object.keys(filters)) {
            if (filters[filter] !== "") {
              _this.apiAddOns += "&" + filter + "=" + filters[filter];
            }
          }

          // Set page size
          if (this.pageSize != "") {
            _this.apiAddOns += "&itemsperpage=" + this.pageSize;
          }

          // Set sort order for products
          if (this.sortQuery.orderBy != "") {
            _this.apiAddOns +=
              "&orderBy=" +
              this.sortQuery.orderBy +
              "&direction=" +
              this.sortQuery.direction;
          }

          // Handle add/remove CAP Supplier
          if (this.capSupplierToggle.supplierId != "") {
            _this.apiAddOns +=
              "&SupplierId=" +
              this.capSupplierToggle.supplierId +
              "&IsAdd=" +
              this.capSupplierToggle.isAdd;
          }

          // new search - set pager to 1
          this.pagination.current_page = 1;

          // Use security headers where needed
          if (this.isClaimQuery) {
            this.getSecureFilteredResults(_this.claimsFilterApi);
          } else if (this.isDirectoryQuery) {
            this.getSecureFilteredResults(_this.directoryFilterApi);
          } else if (this.isUserQuery) {
            this.getSecureFilteredResults(_this.usersFilterApi);
          } else if (this.isProductQuery) {
            this.getSecureFilteredResults(_this.productFilterApi);
          } else if (this.isSpecialQuery) {
            this.getSecureFilteredResults(
              _this.specialFilterApi + `${_this.apiNodeID}&`
            );
          } else if (this.isNewsMySuppliersQuery) {
            this.getSecureFilteredResults(
              _this.newsFilterApi + `${_this.apiNodeID}&`
            );
          } else if (this.isPricingMySuppliersQuery) {
            this.getSecureFilteredResults(
              _this.pricingFilterApi + `${_this.apiNodeID}&`
            );
          } else {
            this.getResults();
          }
        },
        // Other custom methods
        addSearchText(searchText) {
          //* As per LMC191-144, we are redirecting news searches to the global search page.
          var pathname = window.location.pathname.toLowerCase();

          if (pathname.endsWith("news")) {
            window.location.href = `/search?searchText=${searchText}`;
            return;
          }

          this.searchText = searchText;
          this.applyFilters(this.filters);
        },
        addDirectorySearchText(searchText) {
          this.isDirectoryQuery = true;

          this.searchText = searchText;
          this.applyFilters(this.filters);
        },
        clearCookie(cookieName) {
          let date = new Date();
          date.setDate(date.getDate() - 1);
          let yesterday = date.toUTCString();
          document.cookie = cookieName + "=; expires=" + yesterday + ";path=/";
        },
        clearFilters() {
          this.searchText = "";
        },
        paginate(pageSize) {
          window.pager.PageSize = pageSize;
        },
        printNav(cookieName, selectedList) {
          let cookieValue = "";
          let first = true;

          // Build the cookie value
          selectedList.forEach(function(item) {
            if (!first) {
              cookieValue += ":";
            }

            if (item.NodeID != 0) {
              cookieValue += "Kentico|" + item.NodeID;
            } else {
              cookieValue += "LMC|" + item.LmcSpecialID;
            }

            first = false;
          });

          this.setCookie(cookieName, cookieValue);

          window.location.href = "/members/products/specials-promotions/print";
        },
        printProducts(cookieName, selectedList) {
          let cookieValue = "";
          let first = true;

          selectedList.forEach(function(item) {
            if (!first) {
              cookieValue += "|";
            }

            cookieValue += item.SupplierId;
            first = false;
          });

          this.setCookie(cookieName, cookieValue);
          window.location.href = "/members/products/print";
        },
        setCookie(cookieName, cookieValue) {
          document.cookie = cookieName + "=" + cookieValue + ";path=/";
        },
        selectAllCap(newVal) {
          if (!window.isReadOnly) {
            addAllCapSuppliersDialog({
              SupplierName: "All Uncommitted",
            }).then((val) => this.updateCapSuppliers(val));
          }
        },
        toggleCAPSupplier(supplierInfo) {
          this.capSupplierToggle.isAdd = supplierInfo.isAdd;
          this.capSupplierToggle.supplierNumber = supplierInfo.supplierNumber;

          let addSingleCapSuipplierParams = {
            method: "post",
            body: JSON.stringify({
              SupplierNumber: this.capSupplierToggle.supplierNumber,
              IsAdd: this.capSupplierToggle.isAdd,
            }),
            headers: {
              "Content-Type": "application/json",
              AuthenticatedUser: window.LMC.authenticatedUser,
            },
          };

          this.postResults(_this.apiurl, addSingleCapSuipplierParams);
        },
        updateCapSuppliers(newVal) {
          if (newVal === ModalResponse.SUPPLIER_ADDED) {
            let addAllCapApiUrl =
              Constants.ENVIRONMENT_API + "cap/subscribetoall";

            let addAllCapSuppliersParams = {
              method: "post",
              headers: {
                AuthenticatedUser: window.LMC.authenticatedUser,
              },
            };
            this.postResults(
              addAllCapApiUrl,
              addAllCapSuppliersParams,
              this.updateAllCapIcons()
            );
          }
        },
        updateAllCapIcons() {
          for (let result of this.results) {
            result.IsSubscribed = true;
          }
        },
        saveMemberProgramFiltersToSessionStorage() {
          if (typeof Storage !== "undefined") {
            sessionStorage.setItem(
              "memberPrograms",
              JSON.stringify(this.filters)
            );
          }
        },
        savePricingFiltersToSessionStorage() {
          if (typeof Storage !== "undefined") {
            sessionStorage.setItem(
              "pricingFilters",
              JSON.stringify(this.filters)
            );
          }
        },
        saveProductsFiltersToSessionStorage() {
          if (typeof Storage !== "undefined") {
            sessionStorage.setItem(
              "productsFilters",
              JSON.stringify(this.filters)
            );
          }
        },
        saveSpecialsFiltersToSessionStorage() {
          if (typeof Storage !== "undefined") {
            sessionStorage.setItem(
              "specialsFilters",
              JSON.stringify(this.filters)
            );
          }
        },
        selectAllProducts() {
          //Loop through all results on page and add/remove objects as needed
          for (let result of this.results) {
            function checkObject(obj) {
              return obj.SupplierId === result.SupplierId;
            }

            let index = this.selectedProducts.findIndex(checkObject);

            if (!this.allProductsSelected) {
              if (index > -1) {
                this.selectedProducts.splice(index, 1);
              }
            } else {
              if (index === -1) {
                this.selectedProducts.push(result);
              }
            }
          }
          this.productsActionsHandler();
        },
        selectSingleProduct(selection) {
          //Check object against array and add if not present
          function checkSingle(obj) {
            return obj.SupplierId === selection.SupplierId;
          }
          let index = this.selectedProducts.findIndex(checkSingle);
          if (index > -1) {
            this.selectedProducts.splice(index, 1);
          } else {
            this.selectedProducts.push(selection);
          }

          this.productsActionsHandler();
        },
        selectAllSpecials() {
          //Loop through all results on page and add/remove objects as needed
          for (let result of this.results) {
            function checkObject(obj) {
              if (obj.NodeID === 0) {
                return obj.LmcSpecialID === result.LmcSpecialID;
              }

              return obj.NodeID === result.NodeID;
            }

            let index = this.selectedSpecials.findIndex(checkObject);

            if (!this.allSpecialsSelected) {
              if (index > -1) {
                this.selectedSpecials.splice(index, 1);
              }
            } else {
              if (index === -1) {
                this.selectedSpecials.push(result);
              }
            }
          }
          this.specialsActionsHandler();
        },
        selectSingleSpecial(selection) {
          //Check object against array and add if not present
          function checkSingle(obj) {
            if (selection.NodeID === 0) {
              return obj.LmcSpecialID === selection.LmcSpecialID;
            }

            return obj.NodeID === selection.NodeID;
          }
          let index = this.selectedSpecials.findIndex(checkSingle);
          if (index > -1) {
            this.selectedSpecials.splice(index, 1);
          } else {
            this.selectedSpecials.push(selection);
          }

          this.specialsActionsHandler();
        },
        setClaimFilter(filterParams) {
          this.isClaimQuery = true;
          this.filters = filterParams;
          let sortByParam = Object.keys(filterParams).toString();

          // Handle cases where API parameter names aren't consistent
          if (sortByParam == "PONumber") {
            sortByParam = "DealerPONumber";
          } else if (sortByParam == "VendorName") {
            sortByParam = "SupplierName";
          }

          this.setClaimSort(sortByParam);
        },
        setClaimSort(toggle) {
          this.isClaimQuery = true;

          if (this.sortQuery.orderBy != toggle) {
            this.claimsIsDesc = false;
          } else {
            this.claimsIsDesc = !this.claimsIsDesc;
          }

          if (this.claimsIsDesc) {
            this.sortQuery = { orderBy: toggle, direction: "desc" };
          } else {
            this.sortQuery = { orderBy: toggle, direction: "asc" };
          }

          this.applyFilters(this.filters);
        },
        setDirectoryFilter(filterParams) {
          this.isDirectoryQuery = true;

          if (typeof filterParams === "undefined") {
            this.filters = {};
            this.getSecureFilteredResults(_this.directoryFilterApi);

            return;
          }

          this.applyFilters(filterParams);
        },
        setMemberProgramFilters(filterParams) {
          this.filters = filterParams;

          this.saveMemberProgramFiltersToSessionStorage();

          this.applyFilters(this.filters);
        },
        setNewsFilters(filterParams) {
          this.isNewsMySuppliersQuery = true;
          this.filters = filterParams;

          this.applyFilters(this.filters);
        },
        setWebinarsFilters(filterParams) {
          this.filters = filterParams;
          this.applyFilters(this.filters);
        },
        setPricingFilters(filterParams) {
          this.isPricingMySuppliersQuery = true;
          this.filters = filterParams;

          this.savePricingFiltersToSessionStorage();

          this.applyFilters(this.filters);
        },
        setProductSort(toggle) {
          this.isProductQuery = true;
          if (toggle === "toggleNameOrder") {
            this.sortOrder.isNameAsc = !this.sortOrder.isNameAsc;

            if (this.sortOrder.isNameAsc) {
              this.sortQuery = { orderBy: "SupplierName", direction: "asc" };
              this.applyFilters(this.filters);
            } else {
              this.sortQuery = { orderBy: "SupplierName", direction: "desc" };
              this.applyFilters(this.filters);
            }
          }
          if (toggle === "toggleRatingOrder") {
            this.sortOrder.isRatingAsc = !this.sortOrder.isRatingAsc;

            if (this.sortOrder.isRatingAsc) {
              this.sortQuery = { orderBy: "NAPStarRating", direction: "asc" };
              this.applyFilters(this.filters);
            } else {
              this.sortQuery = { orderBy: "NAPStarRating", direction: "desc" };
              this.applyFilters(this.filters);
            }
          }
        },
        setProductFilter(filterParams) {
          this.isProductQuery = true;
          this.filters = filterParams;

          this.saveProductsFiltersToSessionStorage();

          if (typeof filterParams === "undefined") {
            this.filters = {};

            if (_this.apiAddOns.indexOf("itemsperpage") === -1) {
              _this.apiAddOns += "&itemsperpage=" + this.pageSize;
            }

            this.getSecureFilteredResults(_this.productFilterApi);

            return;
          }

          this.applyFilters(this.filters);
        },
        setSpecialsFilter(filterParams) {
          this.isSpecialQuery = true;
          this.filters = filterParams;

          // Save filters in session storage
          this.saveSpecialsFiltersToSessionStorage();

          this.applyFilters(this.filters);
        },
        setUserFilter(filterResponse) {
          this.searchText = filterResponse.query || "";
          this.isUserQuery = true;

          if (filterResponse.isUserPagerCall) {
            this.getSecureFilteredResults(_this.usersFilterApi);
          } else {
            this.applyFilters(this.filters);
          }
        },
        productsActionsHandler() {
          if (this.selectedProducts.length) {
            this.isProductsActionsEnabled = true;
          } else {
            this.isProductsActionsEnabled = false;
          }
        },
        specialsActionsHandler() {
          if (this.selectedSpecials.length) {
            this.isSpecialsActionsEnabled = true;
          } else {
            this.isSpecialsActionsEnabled = false;
          }
        },
        unselectSelectAll() {
          this.allSpecialsSelected = false;
        },
        UpdateShowFilters(value) {
          //Toggle mobile filters
          this.showfilters = value;
        },
        updateSearchText(searchText) {
          this.searchText = searchText;
        },
        viewSelected(cookieName, selectedList) {
          // View Selected Specials
          let cookieValue = "";
          let first = true;
          // Build the cookie value
          selectedList.forEach(function(item) {
            if (!first) {
              cookieValue += ":";
            }

            if (item.NodeID != 0) {
              cookieValue += "Kentico|" + item.NodeID;
            } else if (cookieName == "selectedSpecials") {
              cookieValue += "LMC|" + item.LmcSpecialID;
            } else if (cookieName == "selectedProducts") {
              cookieValue += "LMC|" + item.SupplierId;
            } else {
              cookieValue += "LMC|" + item.LmcProductID;
            }

            first = false;
          });

          let firstSpecial = "";

          if (selectedList[0].NodeAliasPath != null) {
            firstSpecial = selectedList[0].NodeAliasPath;
          } else if (cookieName == "selectedProducts") {
            firstSpecial =
              "/members/products/detail/" + selectedList[0].SupplierId;
          } else {
            firstSpecial =
              "/members/products/specials-promotions/LmcSpecial/" +
              selectedList[0].LmcSpecialID;
          }

          this.setCookie(cookieName, cookieValue);
          window.location.href = firstSpecial;
        },
        viewSelectedProducts(cookieName, selectedList) {
          let cookieValue = selectedList
            .map((item) => item.SupplierId)
            .join("|");
          this.setCookie(cookieName, cookieValue);
          // redirect to first product in list
          window.location.href = `/members/products/detail/${selectedList[0].SupplierId}`;
        },
      },
    });
  }
}
